import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _noop from 'lodash/noop';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// Components
import PropertyControlledComponent from '../../../../../molecules/PropertyControlledComponent';
import FilterHeaderView from './molecules/filterHeaderView';
import FilterHeaderEdit from './molecules/filterHeaderEdit';
import Close from '../../atoms/close';

// Constants
import { DEFAULT_FILTER_GROUP } from '../../../constants/filterSection.filterGroups';
import { CLOSE_FILTER_DIALOG } from './constants/filterHeader.actionTypes';

// Styles
import s from './filterHeader.module.scss';
var FilterHeader = /*#__PURE__*/function (_Component) {
  _inherits(FilterHeader, _Component);
  var _super = _createSuper(FilterHeader);
  function FilterHeader() {
    var _this;
    _classCallCheck(this, FilterHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: CLOSE_FILTER_DIALOG
      });
    });
    return _this;
  }
  _createClass(FilterHeader, [{
    key: "renderViewMode",
    value: function renderViewMode() {
      var _this$props = this.props,
        filterGroups = _this$props.filterGroups,
        isModified = _this$props.isModified,
        onAction = _this$props.onAction,
        selectedFilterGroup = _this$props.selectedFilterGroup,
        shouldHideSaveFilterGroup = _this$props.shouldHideSaveFilterGroup,
        customFilterGroupClass = _this$props.customFilterGroupClass,
        filterHeaderViewContainer = _this$props.filterHeaderViewContainer,
        saveButtonCustomClass = _this$props.saveButtonCustomClass,
        showEditedText = _this$props.showEditedText,
        selectComponentProps = _this$props.selectComponentProps,
        isReadOnly = _this$props.isReadOnly,
        nonRenamable = _this$props.nonRenamable,
        nonDeletable = _this$props.nonDeletable;
      return /*#__PURE__*/React.createElement(FilterHeaderView, {
        filterGroups: filterGroups,
        isModified: isModified,
        onAction: onAction,
        selectedFilterGroup: selectedFilterGroup,
        shouldHideSaveFilterGroup: shouldHideSaveFilterGroup,
        customFilterGroupClass: customFilterGroupClass,
        filterHeaderViewContainer: filterHeaderViewContainer,
        saveButtonCustomClass: saveButtonCustomClass,
        showEditedText: showEditedText,
        selectComponentProps: selectComponentProps,
        isReadOnly: isReadOnly,
        nonRenamable: nonRenamable,
        nonDeletable: nonDeletable
      });
    }
  }, {
    key: "renderEditMode",
    value: function renderEditMode() {
      var _this$props2 = this.props,
        onAction = _this$props2.onAction,
        filterGroupName = _this$props2.filterGroupName,
        errors = _this$props2.errors,
        customFilterGroupClass = _this$props2.customFilterGroupClass,
        filterHeaderEditContainer = _this$props2.filterHeaderEditContainer,
        textualActionsCustomClass = _this$props2.textualActionsCustomClass,
        errorClass = _this$props2.errorClass;
      return /*#__PURE__*/React.createElement(FilterHeaderEdit, {
        filterHeaderEditContainer: filterHeaderEditContainer,
        textualActionsCustomClass: textualActionsCustomClass,
        customFilterGroupClass: customFilterGroupClass,
        onAction: onAction,
        filterGroupName: filterGroupName,
        errors: errors,
        errorClass: errorClass
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var editMode = this.props.editMode;
      if (editMode) {
        return this.renderEditMode();
      }
      return this.renderViewMode();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        shouldShowCloseButton = _this$props3.shouldShowCloseButton,
        shouldHideFilterGroup = _this$props3.shouldHideFilterGroup,
        isReadOnly = _this$props3.isReadOnly;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(s.container, {
          'justify-content-end': shouldHideFilterGroup
        }, {
          'mb-4': isReadOnly
        })
      }, !shouldHideFilterGroup && this.renderContent(), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: shouldShowCloseButton
      }, /*#__PURE__*/React.createElement(Close, {
        onClose: this.handleClose
      })));
    }
  }]);
  return FilterHeader;
}(Component);
FilterHeader.propTypes = {
  editMode: PropTypes.bool,
  filterGroups: PropTypes.array.isRequired,
  isModified: PropTypes.bool,
  onAction: PropTypes.func,
  selectedFilterGroup: PropTypes.string,
  filterGroupName: PropTypes.string,
  errors: PropTypes.object,
  shouldHideSaveFilterGroup: PropTypes.bool,
  customFilterGroupClass: PropTypes.string,
  shouldShowCloseButton: PropTypes.bool,
  filterHeaderEditContainer: PropTypes.bool,
  textualActionsCustomClass: PropTypes.string,
  filterHeaderViewContainer: PropTypes.string,
  saveButtonCustomClass: PropTypes.string,
  errorClass: PropTypes.string,
  showEditedText: PropTypes.bool,
  shouldHideFilterGroup: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  selectComponentProps: PropTypes.object,
  nonRenamable: PropTypes.bool,
  nonDeletable: PropTypes.bool
};
FilterHeader.defaultProps = {
  editMode: undefined,
  isModified: false,
  onAction: _noop,
  selectedFilterGroup: DEFAULT_FILTER_GROUP,
  filterGroupName: '',
  errors: EMPTY_OBJECT,
  shouldHideSaveFilterGroup: false,
  customFilterGroupClass: EMPTY_STRING,
  shouldShowCloseButton: true,
  filterHeaderEditContainer: EMPTY_STRING,
  textualActionsCustomClass: EMPTY_STRING,
  filterHeaderViewContainer: EMPTY_STRING,
  saveButtonCustomClass: EMPTY_STRING,
  errorClass: EMPTY_STRING,
  showEditedText: true,
  shouldHideFilterGroup: false,
  selectComponentProps: EMPTY_OBJECT,
  isReadOnly: false,
  nonRenamable: false,
  nonDeletable: false
};
export default FilterHeader;